module.exports = __webpack_public_path__ + "img/semillitas.ac629023.png";